export default "<p class=\"ion-margin\">\n  {{ (tooltip || '') | translate }}\n</p>\n";